export const getColumnWidth = (breakpoint, numberOfColumns = 0) => {
  const { columnWidth, gutter } = breakpoint;

  return (columnWidth * numberOfColumns) + (gutter * (numberOfColumns - 1));
};

